// extracted by css-extract-rspack-plugin
var _1 = "CIrR3MvU1uBSL6p5N7klmg--";
var _2 = "_7c8xUt7LiwIq5mXZ-wiCPA--";
export { _1 as "container", _2 as "text" }
